var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('v-overlay',{attrs:{"z-index":20,"opacity":"1","fluid":"","color":"white"}},[_c('v-progress-circular',{staticClass:"m-auto",attrs:{"size":70,"width":7,"indeterminate":"","color":"#ff5666"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }